(function (window) {
  'use strict';

  const drawerOpenClass = 'drawer--open';

  function handleOpenDrawer(ev) {
    ev.preventDefault();

    const openDrawer = document.querySelectorAll(`.${drawerOpenClass}`);
    const drawer = this.parentElement.nextElementSibling;

    if (drawer.classList.contains(drawerOpenClass)) {
      for (let i = 0; i < openDrawer.length; i++) {
        openDrawer[i].classList.remove(drawerOpenClass);
      }
    }
    else {
      drawer.classList.add(drawerOpenClass);
    }
  }

  function init() {
    const drawerLinks = document.querySelectorAll('.js-tooltip-drawer-open-link');

    for (let i = 0; i < drawerLinks.length; i++) {
      drawerLinks[i].addEventListener('click', handleOpenDrawer);
    }
  }

  // Allow application JS to reinitialize any instances added with Ajax, etc.
  if (typeof componentEvents !== 'undefined') {
    componentEvents.on('component-init', init);
  }

  init();

})(this);
